import { Link } from "react-router-dom";
import { Card } from "@/components/ui/card";
import type { Booking } from "@/types";

interface BookingHistoryProps {
  bookings: Booking[];
}

export default function BookingHistory({ bookings }: BookingHistoryProps) {
  if (bookings.length === 0) {
    return null;
  }

  const formatDate = (dateStr: string) => {
    const date = new Date(dateStr);
    const day = date.getDate();
    const suffix = day === 1 || day === 21 || day === 31 ? 'st' : 
                   day === 2 || day === 22 ? 'nd' : 
                   day === 3 || day === 23 ? 'rd' : 'th';
    const month = date.toLocaleDateString('en-US', { month: 'short' });
    const year = date.getFullYear();
    return `${month} ${day}${suffix}, ${year}`;
  };

  // Limit to 4 items for display
  const displayedBookings = bookings.slice(0, 4);

  return (
    <div className="space-y-2">
      {displayedBookings.map((booking) => {
        const bookingId = 'BK-' + booking.id.substring(0, 8).toUpperCase();
        return (
          <div key={booking.id}>
            <Link to={`/track/${bookingId}`}>
              <Card className="p-0 hover:border-primary transition-colors flex">
                <div className="w-24 h-24 rounded-lg overflow-hidden flex-shrink-0">
                  <img 
                    src="https://images.unsplash.com/photo-1540189549336-e6e99c3679fe?w=400&h=400&fit=crop" 
                    alt={booking.package?.name || 'Booking'}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="flex-1 p-4">
                  <h3 className="font-bold text-base mb-1">{booking.package?.name || 'The Glow Session'}</h3>
                  <p className="text-sm text-muted-foreground">
                    {formatDate(booking.scheduled_at)} • ${(booking.total_cents / 100).toFixed(2)}
                  </p>
                </div>
              </Card>
            </Link>
          </div>
        );
      })}
    </div>
  );
}